export default [
  {
    path: "profile",
    name: "adminClientProfile",
    component: () => import("@/views/admin/clients/client/profile/index.vue"),
    meta: {
      title: "_.profile",
      breadcrumb: {
        label: "_action.edit",
        "vuex-key": "adminClient"
      }
    }
  },
  {
    path: "security",
    name: "adminClientSecurity",
    component: () => import("@/views/admin/clients/client/security/index.vue"),
    meta: {
      title: "_.security",
      breadcrumb: {
        label: "_action.edit",
        "vuex-key": "adminClient"
      }
    }
  }
];
